import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Icon, Alert } from '@polichat/flamboyant';
import Animation from '../../common/animation';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { initFacebookSDK } from '../channels/CertificationWabaByPoli/MetaSDK/initFacebookSDK';
import { launchWhatsAppSignup } from '../channels/CertificationWabaByPoli/MetaSDK/launchWhatsAppSignup';
import history from '../../../services/history';
import integrations from './integrations-driver';
import { toast } from 'react-toastify';

import AppsIntegrationNewPoliImg from '../../chat/content/chat/modals/src/AppsIntegration';

import PageMainHeader from '../../common/pages/PageMainHeader/PageMainHeader.component';
import PageMainBody from '../../common/pages/PageMainBody/PageMainBody.component';

import { ModalHireAdditionalChannel } from '../channels/AddChannel/ModalHireAdditionalChannel';

import { useCustomerVerifyChannelPlan } from '../channels/AddChannel/useCustomerVerifyChannelPlan';

import {
  Container,
  ListContainer,
  ListItem,
  IntegrationAnimation,
} from './IntegrationsList.styles';
import ZapiModal from './zapiModal';
import { useWhiteLabel } from 'src/hooks/useWhiteLabel';
import { IconPlusIcon } from 'src/assets/illustratorElement/iconPlusIcon/iconPlusIcon';
import { customUseFlags } from 'src/hooks/customUseFlags';
import { useFlags } from 'flagsmith/react';
import useLeadsService from './leads/useLeadsService';
import useOpenPopupMetaLeads from './leads';
import LeadsModal from './leads/LeadsModal';

function IntegrationsList() {
  const customerId = useSelector((state) => state.general.current_customer_id);
  
  // Traduções
  const integrationsTitle = useGlotaT('spa.integrations.title');
  const loadingPlanInfo = useGlotaT('spa.integrations.loadingPlanInfo');
  const errorLoadingPlanInfo = useGlotaT('spa.integrations.errorLoadingPlanInfo');
  const nectarDescription = useGlotaT('spa.integrations.nectar.description');
  const nectarSettings = useGlotaT('spa.integrations.nectar.settings');
  const rdstationDescription = useGlotaT('spa.integrations.rdstation.description');
  const rdstationSettings = useGlotaT('spa.integrations.rdstation.settings');
  const zapiDescription = useGlotaT('spa.integrations.zapi.description');
  const zapiIntegrateChannel = useGlotaT('spa.integrations.zapi.integrateChannel');
  const metaDescription = useGlotaT('spa.integrations.meta.description');
  const metaConnect = useGlotaT('spa.integrations.meta.connect');
  const metaConnected = useGlotaT('spa.integrations.meta.connected');
  const metaConnecting = useGlotaT('spa.integrations.meta.connecting');
  const metaDisconnect = useGlotaT('spa.integrations.meta.disconnect');
  const metaDisconnecting = useGlotaT('spa.integrations.meta.disconnecting');
  const metaDisconnectedSuccess = useGlotaT('spa.integrations.meta.disconnectedSuccess');
  const moreIntegrationsSoon = useGlotaT('spa.integrations.moreIntegrationsSoon');
  const moreIntegrationsSoonPoli = useGlotaT('spa.integrations.moreIntegrationsSoonPoli');
  
  const {
    openPopupMetaLeads,
    isLoading: isLoadingMeta,
    isConnected,
  } = useOpenPopupMetaLeads(customerId);
  const [isZapiModalOpen, setIsZapiModalOpen] = useState(false);
  const [isLeadsModalOpen, setIsLeadsModalOpen] = useState(false);
  const [isFreeTrial, setIsFreeTrial] = useState(false);
  const [isConnectedMeta, setIsConnectedMeta] = useState(isConnected);
  const flag = useFlags(['leads_integration']);
  const leads_integration = customUseFlags(flag.leads_integration);
  const { getCallbackMetaLeadsService, getStatusLeadsService, deleteMetaLeadsService, isLoading, isLoadingDelete } = useLeadsService();
  const LOADING_INTEGRATION_META = isLoading || isLoadingMeta;
  
  let CONNECTED_INTEGRATION_META_LABEL = isConnectedMeta
    ? metaConnected : metaConnect;

  if (LOADING_INTEGRATION_META) {
    CONNECTED_INTEGRATION_META_LABEL = metaConnecting;
  }

  if (isConnectedMeta && !LOADING_INTEGRATION_META) {
    CONNECTED_INTEGRATION_META_LABEL = metaDisconnect;
  }

  if (isLoadingDelete) {
    CONNECTED_INTEGRATION_META_LABEL = metaDisconnecting;
  }

  const matchCustomer = useSelector((state) => {
    const getCustomers = state.general.user.customers;
    return getCustomers.find((element) => element.id == customerId);
  });

  const pushIntegratorConfig = (integrator) => {
    history.push({
      pathname: `/tools/integrations/${integrator}`,
    });
  };

  const ZAPI_ADD_CHANEL_SPA_URL = `/tools/channels/add/broker`;

  const pushZapiIntegration = () => {
    history.push({
      pathname: ZAPI_ADD_CHANEL_SPA_URL,
      state: {
        validated_can_add_channel: true,
      },
    });
  };

  /**
   * additional identifier param
   * DOCS: https://poli-digital.atlassian.net/browse/PS-1697
   */
  const ZAPI_ADDITIONAL_CHANNEL_ID = 2;

  const currentCustomer = useSelector(
    (state) => state?.general?.current_customer_id
  );

  const [
    isModalHireChannelAdditionalOpen,
    setIsModalHireChannelAdditionalOpen,
  ] = useState(false);

  const {
    loading: loadingCustomerChannelPlanInfo,
    error: errorVerifyCustomerChannelPlanInfo,
    channelPlanInfo,
    blocked,
    verifyCustomerCanAddChannel,
  } = useCustomerVerifyChannelPlan();

  async function handleVerifyAdditionalWhatsappChannelIntegration() {
    const {
      should_buy: customerShouldBuyPlan,
      error,
      blocked: customerAreBlockedByOverDue,
    } = await verifyCustomerCanAddChannel(
      currentCustomer,
      ZAPI_ADDITIONAL_CHANNEL_ID
    );

    //customer inadimplente
    if (customerAreBlockedByOverDue) {
      setIsModalHireChannelAdditionalOpen(true);
      return;
    }

    //verificar se precisar comprar adicional ao plano antes de criar canal
    if (customerShouldBuyPlan) {
      setIsModalHireChannelAdditionalOpen(true);
    } else if (!error) {
      handleOpenZapiModal();
      // pushZapiIntegration();
    }
  }

  const handleOpenZapiModal = () => {
    setIsZapiModalOpen(true);
    const freeTrial = matchCustomer.status === 3;
    setIsFreeTrial(freeTrial);
  };

  const handleCloseZapiModal = () => {
    setIsZapiModalOpen(false);
  };

  const closeHireModalAndOpenZapiModal = () => {
    handleOpenZapiModal();
  };

  const [isDarkMode] = useState(() => {
    // getting stored value
    const saved = JSON.parse(localStorage.getItem('@polichat/darkmode'));
    const initialValue = saved;
    return initialValue || false;
  });

  const isWhiteLabel = useWhiteLabel();

  useEffect(() => {
    getStatusLeadsService(customerId)
      .then((res) => {
        if (res && res.status === 200 && res.data?.status === 'Connected') {
          return setIsConnectedMeta(true);
        }
        return setIsConnectedMeta(false);
      })
      .catch((error) => {
        // Erro já tratado no hook, apenas loga se necessário
        console.warn('Erro ao buscar status dos leads:', error);
        setIsConnectedMeta(false);
      });
    initFacebookSDK();
  }, [customerId, getStatusLeadsService]);

  const [debugToken, setDebugToken] = useState();
  useEffect(() => {
    if (debugToken != "ERROR" && debugToken) {
      getCallbackMetaLeadsService(debugToken, customerId)
        .then((res) => {
          if (res && res.status === 200) {
            setIsConnectedMeta(true);
          }
        })
        .catch((error) => {
          // Erro já tratado no hook, apenas loga se necessário
          console.warn('Erro ao processar callback dos leads:', error);
        });
    }
  }, [debugToken, customerId, getCallbackMetaLeadsService]);

  return (
    <>
      <PageMainHeader
        title={integrationsTitle}
        icon="poli-icon pi-integrations-line"
      />
      <PageMainBody>
        <Container>
          {loadingCustomerChannelPlanInfo && (
            <div style={{ margin: '1rem' }}>
              <Alert color="info" style={{ padding: '0.5rem' }}>
                <Animation icon="loading" size="searchTiny" />
                <span
                  style={{ flexGrow: 2, margin: 'auto', marginLeft: '1rem' }}
                >
                  {loadingPlanInfo}
                </span>
              </Alert>
            </div>
          )}
          {!loadingCustomerChannelPlanInfo &&
            errorVerifyCustomerChannelPlanInfo && (
              <div style={{ margin: '1rem' }}>
                <Alert color="danger" style={{ padding: '0.5rem' }}>
                  <Icon icon="poli-icon pi-sad-line" size={40} />
                  <span
                    style={{ flexGrow: 2, margin: 'auto', marginLeft: '1rem' }}
                  >
                    {errorLoadingPlanInfo}
                  </span>
                </Alert>
              </div>
            )}
          <ZapiModal
            isDarkMode={isDarkMode}
            isOpen={isZapiModalOpen}
            isFreeTrial={isFreeTrial}
            onClose={handleCloseZapiModal}
            onSubmit={pushZapiIntegration}
          />

          <ListContainer>
            <ListItem>
              <IconPlusIcon
                firstIcon="onlyLogo"
                secondIcon="nectarIcon"
                secondColor="var(--success)"
              />
              <span>
                {nectarDescription}
              </span>
              <Button
                className="integration-button"
                gradient="primary"
                onClick={() => pushIntegratorConfig(integrations.NECTAR)}
              >
                <Icon icon="poli-icon pi-e-settings-line" size={22} />{' '}
                {nectarSettings}
              </Button>
            </ListItem>
            <ListItem>
              <IconPlusIcon
                firstIcon="onlyLogo"
                secondIcon="rdStationIcon"
                secondColor="var(--success)"
              />
              <span>
                {rdstationDescription}
              </span>
              <Button
                className="integration-button"
                gradient="primary"
                onClick={() => pushIntegratorConfig(integrations.RDSTATION)}
              >
                <Icon icon="poli-icon pi-e-settings-line" size={22} />{' '}
                {rdstationSettings}
              </Button>
            </ListItem>
            {isWhiteLabel.spaTitle !== 'NectarCRM' && (
              <ListItem>
                <IconPlusIcon
                  firstIcon="onlyLogo"
                  secondIcon="zApiIcon"
                  secondColor="var(--success)"
                />
                <span>{zapiDescription}</span>

                <Button
                  className="integration-button"
                  gradient="primary"
                  onClick={handleVerifyAdditionalWhatsappChannelIntegration}
                >
                  <Icon icon="poli-icon pi-e-settings-line" size={22} />{' '}
                  {zapiIntegrateChannel}
                </Button>
              </ListItem>
            )}

            {leads_integration && (
              <ListItem>
                <IconPlusIcon
                  firstIcon="onlyLogo"
                  secondIcon="metaIcon"
                  secondColor="var(--success)"
                />
                <span>
                  {metaDescription}
                </span>

                <Button
                  className="integration-button"
                  gradient={isConnectedMeta ? 'danger' : 'primary'}
                  onClick={() => {
                    if (isConnectedMeta) {
                      setIsLeadsModalOpen(true);
                    } else {
                      launchWhatsAppSignup(setDebugToken, customerId, 'leads');
                    }
                  }}
                  disabled={LOADING_INTEGRATION_META}
                >
                  {LOADING_INTEGRATION_META ? (
                    <Animation
                      icon="loading"
                      style={{
                        borderColor: 'var(--menus-background-sidebar-color)',
                      }}
                      size="minorLittleTiny"
                      color="var(--white)"
                    />
                  ) : (
                    <Icon icon="poli-icon pi-e-settings-line" size={22} />
                  )}
                  {CONNECTED_INTEGRATION_META_LABEL}
                </Button>
              </ListItem>
            )}
            <LeadsModal
              isLoading={isLoadingDelete}
              isOpen={isLeadsModalOpen}
              onClose={() => setIsLeadsModalOpen(false)}
              onSubmit={() => {
                deleteMetaLeadsService(customerId).then((res) => {
                  if (res.status === 204) {
                    toast.success(metaDisconnectedSuccess);
                    setIsConnectedMeta(false);
                    setIsLeadsModalOpen(false)
                  }
                });
              }}
            />
          </ListContainer>
          <IntegrationAnimation>
            <AppsIntegrationNewPoliImg />
            <h2>
              {moreIntegrationsSoon}{' '}
              {!isWhiteLabel.isWl && moreIntegrationsSoonPoli}
            </h2>
          </IntegrationAnimation>
        </Container>
      </PageMainBody>

      {/* MODAL TO HIRE ADDITIONAL CHANNEL */}
      {isModalHireChannelAdditionalOpen && (
        <ModalHireAdditionalChannel
          modalIsOpen={isModalHireChannelAdditionalOpen}
          toggleModal={() =>
            setIsModalHireChannelAdditionalOpen((prev) => !prev)
          }
          channelPlanInfo={channelPlanInfo}
          closeModalAction={closeHireModalAndOpenZapiModal}
          customerId={currentCustomer}
          blocked={blocked}
        />
      )}
    </>
  );
}

export default IntegrationsList;
